module.exports = __webpack_public_path__ + "static/media/poolstokbuzzintro.c0fed378.jpg";